import { Field, InputType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import type { FilterQuery, QueryOptions } from '../repository'

/**
 * Filter criteria for global search query
 *
 * @property query - The search query string (minimum 3 characters)
 */
export interface GlobalSearchFilter {
  /**
   * Search query string
   * Searches across code, name, and summary fields in all modules
   */
  query: string
}

/**
 * Input type for global search GraphQL query
 *
 * Follows the QueryArgs pattern used throughout the application for consistency.
 * The search query is provided in the filter object, and additional options can
 * be specified for sorting and pagination (though pagination is server-controlled
 * for global search).
 *
 * @example
 * ```graphql
 * query {
 *   globalSearch(input: {
 *     filter: { query: "Panel" }
 *     options: {}
 *   }) {
 *     groups {
 *       module
 *       count
 *       results {
 *         _id
 *         code
 *         name
 *       }
 *     }
 *   }
 * }
 * ```
 */
@InputType()
export class GlobalSearchInput {
  /**
   * Filter criteria containing the search query
   */
  @Field(() => GraphQLJSON)
  filter: FilterQuery<GlobalSearchFilter>

  /**
   * Optional query options (sorting, pagination, etc.)
   * Note: Pagination limits are server-controlled for global search
   */
  @Field(() => GraphQLJSON, { nullable: true })
  options?: QueryOptions<any>
}
